import WithFeatureAccess from 'components/WithFeatureAccess';
import { TEST_ID } from 'components/buttons/OptionsButton/constants';

import useFeatureAccess from 'hooks/useFeatureAccess';

import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OptionsItem: FunctionComponent<Props> = ({
    className = '',
    feature,
    isDelete = false,
    isDisabled = false,
    onClick,
    testId = TEST_ID,
    text
}) => {
    const deleteClass = isDelete ? styles.optionItemDelete : '';

    const features = useFeatureAccess();

    const isFeatureAccessible = feature ? features[feature] || false : true;

    const disabledClass = isDisabled ? styles.disabled : '';

    return (
        <span
            aria-disabled={isDisabled}
            className={`${className} ${deleteClass} ${styles.optionsItem} ${disabledClass}`}
            data-testid={testId}
            onClick={isFeatureAccessible && !isDisabled ? onClick : undefined}
        >
            {feature && <WithFeatureAccess feature={feature}>{text}</WithFeatureAccess>}

            {!feature && text}
        </span>
    );
};

export default OptionsItem;
